<template>
	<div class="container">
		<div class="row">
			<sidebar></sidebar>
			<div class="col-sm-10">
				<section class="account-section">
					<div class="row">
						<div class="col-sm-5 no-padding">
							<h2>Mis Direcciones</h2>
						</div>
						<div class="col-sm-offset-10">
							<br>
							<button id="address-button" type="button" class="btn btn-black btn-md pull-right" @click="openForm">
						      	Nueva dirección
						    </button>
						</div>
						<div class="row">
							<div class="col-sm-12 address-form" v-show="new_billing_info">
								<p class="text-general">
									Completa los datos del domicilio donde quieres recibir tu pedido
								</p>
								<form class="form-horizontal" role="form" @submit="createBillingInfo">
									<div class="row">
										<div class="col-sm-6">
											<div class="form-group">
											    <label class="control-label col-sm-3" for="name">
											    	Nombre*
											    </label>
											    <div class="col-sm-9">
											    	<input type="text" class="form-control" :class="{ 'has-error': err.first_name }" v-model="form.first_name" id="name">
												    <div class="tooltip-error" v-if="err.first_name">
												      	Ingresa tu nombre para continuar.
												    </div>
												    <div class="tooltip-error" v-if="err.first_name_msg">
												      	{{ err.first_name_msg }}
												    </div>
											    </div>
										 	</div>
										</div>
										<div class="col-sm-6">
											<div class="form-group">
												<label class="control-label col-sm-3" for="last-name">
													Apellidos*
												</label>
												<div class="col-sm-9">
													<input type="last-name" class="form-control" :class="{ 'has-error': err.last_name }" v-model="form.last_name" id="last-name">
													<div class="tooltip-error" v-if="err.last_name">
												      	Ingresa tu apellido para continuar.
												    </div>
												    <div class="tooltip-error" v-if="err.last_name_msg">
												      	{{ err.last_name_msg }}
												    </div>
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-sm-6">
											<div class="form-group">
												<label class="control-label col-sm-3" for="street">
													Calle*
												</label>
												<div class="col-sm-9">
													<input type="text" class="form-control" :class="{ 'has-error': err.street }" v-model="form.street" id="street">
													<div class="tooltip-error" v-if="err.street">
												      	Ingresa tu calle para continuar.
												    </div>
												    <div class="tooltip-error" v-if="err.street_msg">
												      	{{ err.street_msg }}
												    </div>
												</div>
											</div>
										</div>
										<div class="col-sm-6">
											<div class="form-group">
												<label class="control-label col-sm-3" for="ext">
													N° Ext.*
												</label>
												<div class="col-sm-3"> 
													<input type="text" class="form-control" id="ext" :class="{ 'has-error': err.ext_number }" v-model="form.ext_number">
												    <div class="tooltip-error" v-if="err.ext_number">
												      	Ingresa el número exterior de tu domicilio para continuar.
												    </div>
												    <div class="tooltip-error" v-if="err.ext_number_msg">
												      	{{ err.ext_number_msg }}
												    </div>
												</div>
												<label class="control-label col-sm-3" for="int">
													N° Int.
												</label>
												<div class="col-sm-3"> 
												  <input type="text" class="form-control" id="int" :class="{ 'has-error': err.int_number }" v-model="form.int_number">
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-sm-6">
											<div class="form-group">
												<label class="control-label col-sm-3" for="suburb">
													Colonia*
												</label>
												<div class="col-sm-9">
													<input type="text" class="form-control" id="suburb" :class="{ 'has-error': err.suburb }" v-model="form.suburb">
													<div class="tooltip-error" v-if="err.suburb">
												      	Ingresa el nombre de la colonia para continuar.
												    </div>
												    <div class="tooltip-error" v-if="err.suburb_msg">
												      	{{ err.suburb_msg }}
												    </div>
												</div>
											</div>
										</div>
										<div class="col-sm-6">
											<div class="form-group">
												<label class="control-label col-sm-3" for="c.p">
													C.P.*
												</label>
												<div class="col-sm-9"> 
													<input type="text" class="form-control" id="c.p" :class="{ 'has-error': err.postal_code }" v-model="form.postal_code">
													<div class="tooltip-error" v-if="err.postal_code">
												      	Ingresa el código postal de tu domicilio para continuar.
												    </div>
												    <div class="tooltip-error" v-if="err.postal_code_msg">
												      	{{ err.postal_code_msg }}
												    </div>
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-sm-6">
											<div class="form-group">
												<label class="control-label col-sm-3" for="city">
													Estado*
												</label>
												<div class="col-sm-9">
													<div class="form-control control-select">														
														<select class="select" :class="{ 'has-error': err.state }" v-model="form.state" @change="addCities(form.state)">
															<option value="" disabled selected>Selecciona un estado</option>
															<option v-for="state in render_states" :value="state.id">{{ state.nom_ent }}</option>
														</select>
														<i class="fa fa-caret-down select-caret"></i>
													</div>
													<div class="tooltip-error" v-if="err.state">
												      	Ingresa tu estado para continuar.
												    </div>
												</div>
											</div>
										</div>
										<div class="col-sm-6">
											<div class="form-group">
												<label class="control-label col-sm-3" for="state">
													Ciudad*
												</label>
												<div class="col-sm-9">
													<div class="form-control control-select">
														<select class="select" :class="{ 'has-error': err.city }" v-model="form.city" id="city">
														  	<option value="" disabled selected>Seleccionar primero un estado</option>
														  	<option v-for="city in render_cities" :value="city.id">{{ city.nom_mun }}</option>
														</select>
														<i class="fa fa-caret-down select-caret"></i>
													</div>
												    <div class="tooltip-error" v-if="err.city">
												      	Ingresa tu ciudad para continuar.
												    </div>
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-sm-6">
											<div class="form-group">
												<label class="control-label col-sm-3" for="city">
													Telefono*
												</label>
												<div class="col-sm-9">
													<input type="text" class="form-control" id="city" :class="{ 'has-error': err.phone_number || err.phone_number_msg}" v-model="form.phone_number">
												    <div class="tooltip-error" v-if="err.phone_number">
												      	Ingresa tu número de teléfono para continuar.
												    </div>
												    <div class="tooltip-error" v-if="err.phone_number_msg">
												      	{{ err.phone_number_msg }}
												    </div>
												</div>
											</div>
										</div>
										<!-- <div class="col-sm-6">
											<div class="form-group">
												<label class="control-label col-sm-3" for="state">
													Pais*
												</label>
												<div class="col-sm-9">
												  <input type="text" class="form-control" id="state" :class="{ 'has-error': err.country }" v-model="form.country">
												</div>
											</div>
										</div> -->
									</div>
									
									<div class="row">
										<div class="col-sm-6 col-sm-offset-6">
											<div class="col-sm-9" style="float:right;">
												<button type="submit" class="btn btn-black btn-lg" v-if="!update">Guardar</button>
												<button type="submit" class="btn btn-black btn-lg" v-if="update">Actualizar</button>
											</div>
										</div>
									</div>
									<div class="row">
										<!--<div class="col-sm-4 col-sm-offset-2" >
											<div class="error-container"  v-if="has_error">
										      	<span class="top-caret"><i class="fa fa-play fa-rotate-270"></i></span>
										      	{{ msg_error }}
										    </div>
										</div>-->
											<div class="col-sm-6 pull-right">
												<button type="button" class="btn btn-white btn-md btn-cancel pull-right" @click="closeForm">Cancelar</button>
											</div>
										</div>
									</div>
							    </form>
							</div>

					    	<div v-if="!render_billing_info.length" class="empty padding-left-extra">
					    		No hay direcciones guardadas, agrega algunas.
					    	</div>

					    	<div class="col-sm-12 border-gray" v-for="billing_info in render_billing_info" v-if="!billing_info.rfc">
								<address :billing_info="billing_info" :remove="remove" :edit="edit" :index="$index"></address>
							</div>
						</div>
			    	</div>
				</section>
			</div>
		</div>
	</div>
</template>

<script>
import Breadcrumb from '../../components/User/Breadcrumb.vue';
import Sidebar from '../../components/User/Sidebar.vue';
import Address from '../../components/User/Address.vue';
import {
	removeBillingInfo,
	addBillingInfo,
	addCities,
	updateBillingInfo
} from '../../store/actions';
import { confirm } from '../../scripts/confirm';

var string_regexp = new RegExp(/^[a-zA-Z0-9á-úÁ-Ú_ ]*$/);
var phone_regexp = new RegExp(/^\d{10}$/);
var postal_code_regexp = new RegExp(/^\d{5}$/);
var number_regexp = new RegExp(/^\d/);
var alphanumeric_regexp = new RegExp(/[^\s#°]+(\s+[^\s]+)*$/);

export default {
	data () {
		return {
			new_billing_info: false,
			form: {
				first_name: '',
				street: '',
				suburb: '',
				city: '',
				last_name: '',
				int_number: '',
				ext_number: '',
				state: '',
				postal_code: '',
				// country: '',
				phone_number: ''
			},
			has_error: false,
			msg_error: '',
			err: {},
			update: false,
			edit_index: 0
		}
	},

	vuex: {
		getters: {
			user: state => state.current_user,
			states: state => state.states,
			cities: state => state.cities,
			billing_info: state => {
				let billings = [];

				for (let i = 0, b = state.billing_info; i < b.length; i++) {
					if (!b[i].rfc) {
						billings.push(b[i]);
					}
				}

				return billings;
			}
		},
		actions: {
			removeBillingInfo,
			addBillingInfo,
			addCities,
			updateBillingInfo
		}
	},

	computed: {
		render_billing_info() {
			return this.billing_info;
		},

		render_states() {
			return this.states;
		},

		render_cities() {
			return this.cities;
		}
	},

	methods: {
		remove(billing_info) {
			const vm = this;

			confirm({
				title: 'Eliminar Dirección',
				content: '¿Seguro que deseas eliminar ' + billing_info.street + '?',
				
				confirm: function () {
					vm.removeBillingInfo(vm.user, billing_info);
				},
				
				cancel: function () {}
			});
		},

		edit (billing_info, index) {
			this.new_billing_info = true;
			this.update = true;
			this.edit_index = index;

			// Fix the tooltip for xs and sm screens.
			setTimeout( function(){
				$(".tooltip-error").css({"position": "initial", "margin-top" : "20px"});
				$(".tooltip-error").addClass("center-block");
			}, 10);

			for (let k in billing_info) {
				this.form[k] = billing_info[k];
			}

			delete this.form.business_name;
			delete this.form.is_metroZone;
			delete this.form.rfc;
			delete this.form._method;

			this.form.state = this.setState();
			this.form.city = this.setCity();
		},

		setState () {
			for (let i = 0, s = this.states; i < s.length; i++) {
				if (s[i].id == this.form.city.ent_id) {
					return s[i].id;
				}
			}
		},

		setCity () {
			this.addCities(this.form.state);
			return this.form.city.id;
		},

		createBillingInfo(e) {
			e.preventDefault();
			this.has_error = false;
			this.msg_error = '';
			this.err = {};
			this.validations();

			// Fix the tooltip for xs and sm screens.
			setTimeout( function(){
				$(".tooltip-error").css({"position": "initial", "margin-top" : "20px"});
				$(".tooltip-error").addClass("center-block");
			}, 10);

			if (this.has_error) {
				return;
			}

			if (this.update) {
				this.updateBillingInfo(this.user, this.form, this.edit_index, { with_quote: 0 });
			} else {
				this.addBillingInfo(this.user, this.form, { with_quote: 0 });
			}

			this.resetForm();
			this.update = false;
			this.new_billing_info = false;
		},

		validations() {
			for (var k in this.form) {
				if (!this.form[k] && k != 'int_number') {
					this.err[k] = true;
					this.has_error = true;
					this.form[k] = '';
				}
			}

			/*if(!this.form.int_number){
				this.form.int_number = '';
			}*/

			if(!this.form.phone_number){
				this.err.phone_number = true;
				this.has_error = true;
			}

			if (!this.form.phone_number.match(phone_regexp) && !this.err.phone_number) {
				this.has_error = true;
				this.err.phone_number_msg = 'Ingresa tu número a 10 dígitos para continuar.';
			}

			if(!this.form.city){
				this.err.city = true;
				this.has_error = true;
				this.msg_error = 'Ingresa una ciudad para continuar';
			}

			if(!this.form.state){
				this.err.state = true;
				this.has_error = true;
				this.msg_error = 'Ingresa un estado para continuar';
			}

			if(!this.form.postal_code){
				this.err.postal_code = true;
				this.has_error = true;
			}

			if (!this.form.postal_code.match(postal_code_regexp) && !this.err.postal_code) {
				this.has_error = true;
				this.err.postal_code_msg = 'Ingresa un código postal válido para continuar.';
			}

			//validate only regexp, because int can be empty
			if (!this.form.int_number.match(alphanumeric_regexp) && this.form.int_number) {
				this.has_error = true;
				this.err.int_number_msg = 'Ingresa solamente números para continuar.';
			}

			if(!this.form.suburb){
				this.err.suburb = true;
				this.has_error = true;
			}

			if (!this.form.suburb.match(string_regexp) && !this.err.suburb) {
				this.has_error = true;
				this.err.suburb_msg = 'Ingresa solamente letras para continuar.';
			}

			if(!this.form.ext_number){
				this.has_error = true;
				this.err.ext_number = true;
			}

			if (!this.form.ext_number.match(alphanumeric_regexp) && !this.err.ext_number) {
				this.has_error = true;
				this.err.ext_number_msg = 'Ingresa solamente números para continuar.';
			}

			if(!this.form.street){
				this.err.street = true;
				this.has_error = true;
			}

			if (!this.form.street.match(alphanumeric_regexp) && !this.err.street) {
				this.has_error = true;
				this.err.street_msg = 'Ingresa solamente letras para continuar.';
			}

			if(!this.form.last_name){
				this.err.last_name = true;
				this.has_error = true;
			}

			if (!this.form.last_name.match(string_regexp) && !this.err.last_name ) {
				this.has_error = true;
				this.err.last_name_msg = 'Ingresa solamente letras para continuar.';
			}

			if(!this.form.first_name){
				this.err.first_name = true;
				this.has_error = true;
			}

			if (!this.form.first_name.match(string_regexp) && !this.err.first_name ) {
				this.has_error = true;
				this.err.first_name_msg = 'Ingresa solamente letras para continuar.';
			}
		},

		openForm() {
			this.new_billing_info = true;
		},

		closeForm() {
			this.new_billing_info = false;
			this.update = false;
			this.resetForm();
			this.err = {};
			this.has_error = false;
		},

		resetForm () {
			for (let k in this.form) {
				this.form[k] = null;
			}
		}
	},
	/*ready: function(){
		//Tooltips
		$(".tooltip-error").css({"position": "initial", "margin-top" : "20px"});
		$(".tooltip-error").addClass("center-block");
	},*/

  components: {
  	Breadcrumb,
  	Sidebar,
  	Address,
  }
};
</script>


// WEBPACK FOOTER //
// Address.vue?6987ab15